// angular import
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  // public props
  @Input() type: string;
  @Input() dismiss: string;

  // public method
  dismissAlert(element) {
    element.remove();
  }
}
